export default __webpack_public_path__ + "static/media/leader_notes.398f1cb3.pdf";